import React from 'react'
import { Container, Image, Header, Button } from 'semantic-ui-react'


const ErrorPage = () => (
  <Container textAlign='center' style={{ marginTop: '154px' }}>
    <Image centered src='https://locus-cdn.s3.amazonaws.com/noun_Error_1765800.svg' />
    <Header as='h2'>Sorry, something went wrong.</Header>
    <p style={{ fontSize: '1.33em', width: '415px', marginLeft: 'auto', marginRight: 'auto' }}>
      An unexpected error occurred.
      Please go back to the main page.
    </p>
    <Button
      primary
      size='large'
      style={{ marginTop: '1em' }}
      onClick={() => { window.history.back() }}
    >
      Go back
    </Button>
  </Container>
)

export default ErrorPage
